import { render, staticRenderFns } from "./page-content-type-sp_constructed.vue?vue&type=template&id=29e39850&scoped=true"
import script from "./page-content-type-sp_constructed.vue?vue&type=script&lang=js"
export * from "./page-content-type-sp_constructed.vue?vue&type=script&lang=js"
import style0 from "./page-content-type-sp_constructed.vue?vue&type=style&index=0&id=29e39850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e39850",
  null
  
)

export default component.exports